import { Typography } from '@atlas-metrics/design-system';
import { WidgetDataType, WidgetNoneType } from '@atlas-metrics/microsite-types';
import React, { PropsWithChildren } from 'react';

import clsxm from '@/lib/clsxm';
import { FormatValueFn } from '@/hooks/useFormatValue';

type WidgetProps = PropsWithChildren<{
  title: string;
  number: number;
  dataType: WidgetDataType | WidgetNoneType;
  className?: string;
  color?: string;
  onMouseOver?: () => void;
  onMouseOut?: () => void;
  noIndentation?: boolean;
  formatValue: FormatValueFn;
}>;

const ChartLegend: React.FC<WidgetProps> = ({
  title,
  number,
  dataType,
  color,
  className,
  onMouseOver,
  onMouseOut,
  noIndentation,
  formatValue,
}) => {
  const widgetContent = (
    <div
      className={clsxm(
        'cursor-pointer rounded-lg bg-ds-grey-50 p-4 hover:bg-ds-grey-50',
        className
      )}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
    >
      <div className='flex items-center'>
        {color && (
          <div
            className='mr-4 h-2.5 w-2.5 shrink-0 rounded-sm'
            style={{ background: color }}
          ></div>
        )}
        <Typography
          variant='body-m'
          className='mr-4 break-words text-left font-semibold text-ds-grey-700'
        >
          {title}
        </Typography>
      </div>
      <Typography
        variant='body-m'
        className={clsxm(
          'ml-7 mt-2 shrink-0 whitespace-pre-line break-words text-ds-grey-950',
          noIndentation && clsxm('ml-0')
        )}
      >
        {typeof formatValue === 'function' && formatValue(number, dataType)}
      </Typography>
    </div>
  );
  return widgetContent;
};

export default ChartLegend;
